class SubscriptionGroups extends HTMLElement {
  selectedVariantId = null;
  selectedSubscriptionId = null;

  constructor() {
    super();
    this.submitBtn = this.querySelector('.subscription-groups__submit-btn');
    this.optionButtons = this.querySelectorAll('.subscriptions-group__option');
    this.groups = this.querySelectorAll('.subscriptions-group__container');
    this.plans = this.querySelectorAll('.subscriptions-group__plan');
    this.nestedBoxes = this.querySelectorAll('.subscriptions-group__box--nested');
    this.errorMessageElement = this.querySelector('.subscription-groups__error-message');

    this.optionButtons.forEach((button) => {
      button.addEventListener('click', this.handleOptionButtonClick.bind(this));
    });

    this.plans.forEach((plan) => {
      plan.addEventListener('click', this.handlePlanClick.bind(this));
    });

    this.nestedBoxes.forEach((box) => {
      box.addEventListener('click', (e) => {
        e.target
          .closest('.subscriptions-group__container')
          .querySelectorAll('.subscriptions-group__plan')
          .forEach((plan) => {
            plan.classList.remove('subscriptions-group__plan--selected');
          });

        const plan = box.querySelectorAll('.subscriptions-group__plan')?.[0];
        plan.classList.add('subscriptions-group__plan--selected');

        this.selectedVariantId = plan.dataset.variantId;
        this.selectedSubscriptionId = plan.dataset.subscriptionId;
        this.updatePriceLabel(plan);
      });
    });

    this.updateSelectedDetails();
    this.submitBtn.addEventListener('click', this.handleAddToCart.bind(this));
  }

  updateSelectedDetails() {
    const selectedOption = this.querySelector('.subscriptions-group__option--selected');
    const target = selectedOption.dataset.target;
    const selectedPlan = this.querySelector(`[data-id="${target}"] .subscriptions-group__plan--selected`);

    this.updatePriceLabel(selectedPlan);

    this.selectedVariantId = selectedPlan.dataset.variantId;
    this.selectedSubscriptionId = selectedPlan.dataset.subscriptionId;
  }

  handleOptionButtonClick(e) {
    const buttonTarget = e.target.closest('button');
    const target = buttonTarget.dataset.target;

    this.optionButtons.forEach((button) => {
      button.classList.remove('subscriptions-group__option--selected');
    });

    this.groups.forEach((group) => {
      group.classList.remove('subscriptions-group__container--selected');
    });

    buttonTarget.classList.add('subscriptions-group__option--selected');
    this.querySelector(`[data-id="${target}"]`).classList.add('subscriptions-group__container--selected');
    this.updateSelectedDetails();
  }

  handlePlanClick(e) {
    const buttonTarget = e.target.closest('button');

    e.target
      .closest('.subscriptions-group__container')
      .querySelectorAll('.subscriptions-group__plan')
      .forEach((plan) => {
        plan.classList.remove('subscriptions-group__plan--selected');
      });

    buttonTarget.classList.add('subscriptions-group__plan--selected');

    this.updatePriceLabel(buttonTarget);

    this.selectedVariantId = buttonTarget.dataset.variantId;
    this.selectedSubscriptionId = buttonTarget.dataset.subscriptionId;

    e.stopPropagation();
  }

  updatePriceLabel(element) {
    const text = element.dataset.atcLabel;
    const price = element.dataset.price;
    const pricePerBox = element.dataset.pricePerBox;

    this.submitBtn.textContent = text + ' ' + price;
    if (pricePerBox) {
      const pricePerBoxElement = document.querySelector('.ProductMeta__Price');
      if (pricePerBoxElement) {
        pricePerBoxElement.textContent = pricePerBox.replace(' per box', '');
      }
    }

    const nestedBox = element.closest('.subscriptions-group__box--nested');
    if (nestedBox) {
      const dataContainer = nestedBox.querySelector('.subscriptions-group__plan-select');
      const currentPrice = dataContainer.querySelector('.subscriptions-group__box-price-current');
      const comparePrice = dataContainer.querySelector('.subscriptions-group__box-price-compare');
      const planDescription = dataContainer.querySelector('.subscriptions-group__box-description');

      currentPrice.textContent = price;
      comparePrice.textContent = element.dataset.compareAtPrice;
      planDescription.textContent = element.dataset.description;
    }
  }

  async handleAddToCart(e) {
    try {
      this.submitBtn.disabled = true;

      e.preventDefault();
      const properties = {};
      if (this.selectedSubscriptionId) {
        properties['og_subscription'] = 'true';
      }

      await Shopify.addToCart([
        {
          id: this.selectedVariantId,
          quantity: 1,
          selling_plan: this.selectedSubscriptionId,
          properties,
        },
      ]);
    } catch (error) {
      console.error('Failed to add item to cart', error);
      this.errorMessageElement.textContent = 'There was an error adding this item to the cart';
    } finally {
      this.submitBtn.disabled = false;
    }
  }
}

customElements.define('subscription-groups', SubscriptionGroups);